import React, { createContext, useContext, useState } from 'react';

// Type for a pinned file (can be extended as needed)
export interface PinnedFile {
  id: string;
  name: string;
  url: string;
  type: string;
  size: number;
  contextKey: string; // e.g., 'cpu', 'overview', etc.
}

interface PinnedFileContextType {
  pinnedFiles: Record<string, PinnedFile | null>;
  pinFile: (contextKey: string, file: PinnedFile) => void;
  unpinFile: (contextKey: string) => void;
}

const PinnedFileContext = createContext<PinnedFileContextType | undefined>(undefined);

export const usePinnedFile = () => {
  const ctx = useContext(PinnedFileContext);
  if (!ctx) throw new Error('usePinnedFile must be used within a PinnedFileProvider');
  return ctx;
};

export const PinnedFileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pinnedFiles, setPinnedFiles] = useState<Record<string, PinnedFile | null>>({});

  const pinFile = (contextKey: string, file: PinnedFile) => {
    setPinnedFiles(prev => ({ ...prev, [contextKey]: file }));
  };

  const unpinFile = (contextKey: string) => {
    setPinnedFiles(prev => ({ ...prev, [contextKey]: null }));
  };

  return (
    <PinnedFileContext.Provider value={{ pinnedFiles, pinFile, unpinFile }}>
      {children}
    </PinnedFileContext.Provider>
  );
};
